/* Aura Mobile Suite - Theme JavaScript */
(function() {
  'use strict';

  /* Mobile menu toggle */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      var isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isExpanded));
      if (mobileMenu.hasAttribute('hidden')) {
        mobileMenu.removeAttribute('hidden');
      } else {
        mobileMenu.setAttribute('hidden', '');
      }
    });
  }

  /* Quantity controls */
  var qtyDecr = document.querySelector('[data-quantity-decr]');
  var qtyIncr = document.querySelector('[data-quantity-incr]');
  var qtyInput = document.querySelector('#quantity');
  if (qtyDecr && qtyInput) {
    qtyDecr.addEventListener('click', function() {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
  }
  if (qtyIncr && qtyInput) {
    qtyIncr.addEventListener('click', function() {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* Quick add to cart */
  var quickAddForms = document.querySelectorAll('[data-quick-add-form]');
  quickAddForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then(function(response) { return response.json(); })
      .then(function() { updateCartCount(); })
      .catch(function() { form.submit(); });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var counts = document.querySelectorAll('[data-cart-count]');
        counts.forEach(function(el) { el.textContent = cart.item_count; });
      });
  }

  /* Cart item quantity update */
  var cartItemControls = document.querySelectorAll('[data-decrease], [data-increase]');
  cartItemControls.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('[data-cart-item]');
      if (!item) return;
      var line = item.querySelector('[data-line-id]');
      var quantity = item.querySelector('[data-quantity-value]');
      if (!line || !quantity) return;
      var current = parseInt(quantity.textContent, 10) || 1;
      var newQty = btn.getAttribute('data-decrease') !== null ? Math.max(0, current - 1) : current + 1;
      var formData = new FormData();
      formData.append('line', line.value);
      formData.append('quantity', newQty);
      fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      }).then(function(response) { return response.json(); })
      .then(function() {
        if (newQty === 0) {
          item.remove();
        } else {
          quantity.textContent = newQty;
        }
        updateCartCount();
      });
    });
  });

  /* Cart item remove */
  var removeButtons = document.querySelectorAll('[data-remove]');
  removeButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('[data-cart-item]');
      if (!item) return;
      var line = item.querySelector('[data-line-id]');
      if (!line) return;
      var formData = new FormData();
      formData.append('line', line.value);
      formData.append('quantity', 0);
      fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      }).then(function() {
        item.remove();
        updateCartCount();
      });
    });
  });

  /* Filters toggle for mobile */
  var filtersToggle = document.querySelector('[data-filters-toggle]');
  var filters = document.querySelector('.aura-filters');
  if (filtersToggle && filters) {
    filtersToggle.addEventListener('click', function() {
      filters.classList.toggle('aura-filters--open');
    });
  }

  /* Product image gallery thumbnails */
  var thumbs = document.querySelectorAll('.aura-product-gallery__thumb');
  var mainImage = document.querySelector('.aura-product-gallery__image');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var img = thumb.querySelector('img');
      if (img && mainImage) {
        mainImage.src = img.src;
        mainImage.alt = img.alt;
      }
      thumbs.forEach(function(t) { t.classList.remove('aura-product-gallery__thumb--active'); });
      thumb.classList.add('aura-product-gallery__thumb--active');
    });
  });

  /* Sticky add to cart bar */
  var stickyBar = document.querySelector('[data-sticky-add-to-cart]');
  if (stickyBar) {
    var productInfo = document.querySelector('.aura-product-info');
    if (productInfo) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('aura-product-sticky-bar--visible');
          } else {
            stickyBar.classList.remove('aura-product-sticky-bar--visible');
          }
        });
      }, { threshold: 0 });
      observer.observe(productInfo);
    }
  }

  /* Newsletter form */
  var newsletterForm = document.querySelector('.aura-newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = newsletterForm.querySelector('button[type="submit"]');
      if (btn) {
        btn.textContent = 'Joining…';
        btn.disabled = true;
      }
      var formData = new FormData(newsletterForm);
      fetch('/contact#newsletter', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).then(function() {
        if (btn) btn.textContent = 'Joined!';
      }).catch(function() {
        if (btn) {
          btn.textContent = 'Join';
          btn.disabled = false;
        }
      });
    });
  }
})();